
import PropTypes from 'prop-types'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useCollapsible } from 'utils'
import { createOnFilter } from 'filter'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import Collapse from '@mui/material/Collapse'
import Stack from '@mui/material/Stack'
import MuiFormSelect from 'frame/components/mui-form-select'

const FilterAttributes = ({ filters, filtered, onFilter }) => {
  const { collapsed, onToggleCollapsible } = useCollapsible(true)
  const onSelect = createOnFilter(onFilter)
  const hasList = (list) => list.length > 0
  const { costCentres, trackings, agreementTypes, fmoTypes } = filters

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingY: 1,
          paddingX: 0,
          cursor: 'pointer',
        }}
        onClick={onToggleCollapsible}>
        <Typography variant="h5">Filters</Typography>
        {collapsed ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </Box>
      <Divider />
      <Collapse in={collapsed}>
        <Stack gap={2} py={2}>
          {hasList(costCentres) && (
            <MuiFormSelect
              id="costCentre"
              label="Cost Centre"
              options={[{ label: 'No cost centre', value: '-' }, ...costCentres]}
              value={filtered.costCentre}
              onChange={onSelect('costCentre')}
              includeEmptyOption
              emptyOptionLabel="All cost centres"/>
          )}
          {hasList(trackings) && (
            <MuiFormSelect
              id="tracking"
              label="Tracking"
              options={trackings}
              value={filtered.tracking}
              onChange={onSelect('tracking')}
              includeEmptyOption/>
          )}
          {hasList(agreementTypes) && (
            <MuiFormSelect
              id="agreementType"
              label="Agreement Type"
              options={agreementTypes}
              value={filtered.agreementType}
              onChange={onSelect('agreementType')}
              includeEmptyOption/>
          )}
          {hasList(fmoTypes) && (
            <MuiFormSelect
              id="fmoType"
              label="FMO"
              options={fmoTypes}
              value={filtered.fmoType}
              onChange={onSelect('fmoType')}
              includeEmptyOption/>
          )}
        </Stack>
      </Collapse>
    </Box>
  )
}

FilterAttributes.propTypes = {
  filters: PropTypes.object.isRequired,
  filtered: PropTypes.object.isRequired,
  onFilter: PropTypes.func.isRequired,
}

export default FilterAttributes
